// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primevendor_form_overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.58);
  backdrop-filter: blur(5px);
}

.primevendor_form_modal {
  width: min(900px, 96vw);
  max-height: 92vh;
  overflow-y: auto;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.2);

  /* Hide scrollbar */
  -ms-overflow-style: none;  /* IE & Edge */
  scrollbar-width: none;     /* Firefox */
}

/* Chrome, Safari, Opera */
.primevendor_form_modal::-webkit-scrollbar {
  display: none;
}
.primevendor_form_header {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 26px;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
}

.primevendor_form_header h2 { margin: 0; color: #0f172a; font-size: 22px; }
.primevendor_form_header p { margin: 5px 0 0; color: #64748b; font-size: 13px; }

.primevendor_close_btn {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  border: 0;
  border-radius: 50%;
  background: #f1f5f9;
  color: #334155;
  cursor: pointer;
}

.primevendor_close_btn:hover { background: #fee2e2; color: #dc2626; }

.primevendor_form_grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 24px;
  padding: 24px 26px;
}

.primevendor_form_group { display: flex; flex-direction: column; gap: 7px; }
.primevendor_full_width { grid-column: 1 / -1; }
.primevendor_form_group label,
.primevendor_document_section > label { color: #334155; font-size: 13px; font-weight: 700; }

.primevendor_form_group input,
.primevendor_form_group textarea {
  width: 100%;
  border: 1px solid #dbe2ea;
  border-radius: 10px;
  padding: 11px 13px;
  outline: none;
  background: #fff;
  color: #0f172a;
  font: inherit;
}

.primevendor_form_group input:focus,
.primevendor_form_group textarea:focus { border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); }
.primevendor_form_group input:disabled,
.primevendor_form_group textarea:disabled { background: #f8fafc; color: #334155; opacity: 1; }
.primevendor_form_group textarea { resize: vertical; }

.primevendor_document_section { padding: 0 26px 24px; }
.primevendor_document_section p { margin: 8px 0; color: #64748b; font-size: 13px; word-break: break-word; }
.primevendor_existing_document { color: #334155 !important; }

.primevendor_upload {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 9px;
  padding: 15px;
  border: 1px dashed #93c5fd;
  border-radius: 12px;
  background: #eff6ff;
  color: #2563eb;
  cursor: pointer;
}

.primevendor_form_actions {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 26px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
}

.primevendor_form_actions button { min-width: 120px; height: 42px; border: 0; border-radius: 10px; font-weight: 700; cursor: pointer; }
.primevendor_cancel_btn { background: #e2e8f0; color: #334155; }
.primevendor_save_btn { background: #2563eb; color: #fff; }
.primevendor_save_btn:disabled { cursor: not-allowed; opacity: 0.65; }
.primevendor_form_state { padding: 60px 26px; text-align: center; color: #64748b; }
.primevendor_form_error { margin: 18px 26px 0; padding: 11px 13px; border-radius: 9px; background: #fef2f2; color: #b91c1c; font-size: 13px; }
.delete-modal .primevendor_form_error { margin: 12px 0 0; }
.primevendor_form_overlay .delete-modal {
  box-sizing: border-box;
  width: min(420px, 100%);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.2);
}

@media (max-width: 680px) {
  .primevendor_form_overlay { padding: 8px; }
  .primevendor_form_modal { max-height: 96vh; }
  .primevendor_form_grid { grid-template-columns: 1fr; padding: 20px; }
  .primevendor_full_width { grid-column: auto; }
  .primevendor_form_header, .primevendor_form_actions { padding: 16px 20px; }
  .primevendor_document_section { padding: 0 20px 20px; }
  .primevendor_form_actions { flex-direction: column-reverse; }
  .primevendor_form_actions button { width: 100%; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/primevendorform.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;;EAE1C,mBAAmB;EACnB,wBAAwB,GAAG,cAAc;EACzC,qBAAqB,MAAM,YAAY;AACzC;;AAEA,0BAA0B;AAC1B;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,8BAA8B,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;AAC1E,6BAA6B,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;;AAE/E;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;;AAEpE;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,kBAAkB;AACpB;;AAEA,0BAA0B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC3E,0BAA0B,mBAAmB,EAAE;AAC/C;wCACwC,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAE3F;;EAEE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;yCACyC,qBAAqB,EAAE,4CAA4C,EAAE;AAC9G;4CAC4C,mBAAmB,EAAE,cAAc,EAAE,UAAU,EAAE;AAC7F,mCAAmC,gBAAgB,EAAE;;AAErD,gCAAgC,oBAAoB,EAAE;AACtD,kCAAkC,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,sBAAsB,EAAE;AAC1G,iCAAiC,yBAAyB,EAAE;;AAE5D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,mCAAmC,gBAAgB,EAAE,YAAY,EAAE,SAAS,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACtI,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,wBAAwB,mBAAmB,EAAE,WAAW,EAAE;AAC1D,iCAAiC,mBAAmB,EAAE,aAAa,EAAE;AACrE,0BAA0B,kBAAkB,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAClF,0BAA0B,mBAAmB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC7I,wCAAwC,gBAAgB,EAAE;AAC1D;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B,YAAY,EAAE;EAC1C,0BAA0B,gBAAgB,EAAE;EAC5C,yBAAyB,0BAA0B,EAAE,aAAa,EAAE;EACpE,0BAA0B,iBAAiB,EAAE;EAC7C,sDAAsD,kBAAkB,EAAE;EAC1E,gCAAgC,oBAAoB,EAAE;EACtD,4BAA4B,8BAA8B,EAAE;EAC5D,mCAAmC,WAAW,EAAE;AAClD","sourcesContent":[".primevendor_form_overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 99999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(15, 23, 42, 0.58);\n  backdrop-filter: blur(5px);\n}\n\n.primevendor_form_modal {\n  width: min(900px, 96vw);\n  max-height: 92vh;\n  overflow-y: auto;\n  border-radius: 18px;\n  background: #fff;\n  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.2);\n\n  /* Hide scrollbar */\n  -ms-overflow-style: none;  /* IE & Edge */\n  scrollbar-width: none;     /* Firefox */\n}\n\n/* Chrome, Safari, Opera */\n.primevendor_form_modal::-webkit-scrollbar {\n  display: none;\n}\n.primevendor_form_header {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 26px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #fff;\n}\n\n.primevendor_form_header h2 { margin: 0; color: #0f172a; font-size: 22px; }\n.primevendor_form_header p { margin: 5px 0 0; color: #64748b; font-size: 13px; }\n\n.primevendor_close_btn {\n  display: grid;\n  width: 38px;\n  height: 38px;\n  place-items: center;\n  border: 0;\n  border-radius: 50%;\n  background: #f1f5f9;\n  color: #334155;\n  cursor: pointer;\n}\n\n.primevendor_close_btn:hover { background: #fee2e2; color: #dc2626; }\n\n.primevendor_form_grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px 24px;\n  padding: 24px 26px;\n}\n\n.primevendor_form_group { display: flex; flex-direction: column; gap: 7px; }\n.primevendor_full_width { grid-column: 1 / -1; }\n.primevendor_form_group label,\n.primevendor_document_section > label { color: #334155; font-size: 13px; font-weight: 700; }\n\n.primevendor_form_group input,\n.primevendor_form_group textarea {\n  width: 100%;\n  border: 1px solid #dbe2ea;\n  border-radius: 10px;\n  padding: 11px 13px;\n  outline: none;\n  background: #fff;\n  color: #0f172a;\n  font: inherit;\n}\n\n.primevendor_form_group input:focus,\n.primevendor_form_group textarea:focus { border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); }\n.primevendor_form_group input:disabled,\n.primevendor_form_group textarea:disabled { background: #f8fafc; color: #334155; opacity: 1; }\n.primevendor_form_group textarea { resize: vertical; }\n\n.primevendor_document_section { padding: 0 26px 24px; }\n.primevendor_document_section p { margin: 8px 0; color: #64748b; font-size: 13px; word-break: break-word; }\n.primevendor_existing_document { color: #334155 !important; }\n\n.primevendor_upload {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 9px;\n  padding: 15px;\n  border: 1px dashed #93c5fd;\n  border-radius: 12px;\n  background: #eff6ff;\n  color: #2563eb;\n  cursor: pointer;\n}\n\n.primevendor_form_actions {\n  position: sticky;\n  bottom: 0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 18px 26px;\n  border-top: 1px solid #e2e8f0;\n  background: #fff;\n}\n\n.primevendor_form_actions button { min-width: 120px; height: 42px; border: 0; border-radius: 10px; font-weight: 700; cursor: pointer; }\n.primevendor_cancel_btn { background: #e2e8f0; color: #334155; }\n.primevendor_save_btn { background: #2563eb; color: #fff; }\n.primevendor_save_btn:disabled { cursor: not-allowed; opacity: 0.65; }\n.primevendor_form_state { padding: 60px 26px; text-align: center; color: #64748b; }\n.primevendor_form_error { margin: 18px 26px 0; padding: 11px 13px; border-radius: 9px; background: #fef2f2; color: #b91c1c; font-size: 13px; }\n.delete-modal .primevendor_form_error { margin: 12px 0 0; }\n.primevendor_form_overlay .delete-modal {\n  box-sizing: border-box;\n  width: min(420px, 100%);\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.2);\n}\n\n@media (max-width: 680px) {\n  .primevendor_form_overlay { padding: 8px; }\n  .primevendor_form_modal { max-height: 96vh; }\n  .primevendor_form_grid { grid-template-columns: 1fr; padding: 20px; }\n  .primevendor_full_width { grid-column: auto; }\n  .primevendor_form_header, .primevendor_form_actions { padding: 16px 20px; }\n  .primevendor_document_section { padding: 0 20px 20px; }\n  .primevendor_form_actions { flex-direction: column-reverse; }\n  .primevendor_form_actions button { width: 100%; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
